module.exports = __webpack_public_path__ + "static/1-500e8fd4558660a135ae04b12691ed70.jpg";